module.exports = __webpack_public_path__ + "static/media/29.41334c78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/29.jpg
// module id = 974
// module chunks = 0